export class User {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  role: string;
 email: string;
  position: string;
  phone: string;
  disabled?: boolean;
  roleObject: any;
  image: string;
  password: string;
  salary: any;
  percentage: any;
  expenses: any;
  branch: string;
  branchObject: any;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.firstName = apiModel.first_name;
    this.lastName = apiModel.last_name;
    this.name = `${apiModel.first_name} ${apiModel.last_name}`;
    if (apiModel.role) {
      this.role = apiModel.role.name;
      this.roleObject = apiModel.role;
    }
    if (apiModel.branch) {
      this.branch = apiModel.branch.name;
      this.branchObject = apiModel.branch;
    }
    this.position = apiModel.position;
   this.email = apiModel.email;
    this.phone = apiModel.phone;
    this.image = apiModel.image ? apiModel.image : '';
    this.password = apiModel.password;
    this.salary = apiModel.salary;
    this.percentage = apiModel.percentage;

   return this;

  }
}



